export default __webpack_public_path__ + "static/Gwiazdzista-1-a294bf32e182ce608e18972ffea3bbd5.png";